import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import SkillsShowcase from './components/SkillsShowcase';
import ExperienceTimeline from './components/ExperienceTimeline';
import FeaturedProjects from './components/FeaturedProjects';
import RecentBlogPosts from './components/RecentBlogPosts';
import SocialMediaLinks from './components/SocialMediaLinks';
import Footer from './components/Footer';

const HomeLanding = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title> Joe Graziano</title>
        <meta name="description" content="Explore professional insights, industry knowledge, and expert perspectives on web development, design, career growth, and technology trends." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main>
          <HeroSection />
          <SkillsShowcase />
          <ExperienceTimeline />
          <FeaturedProjects />
          <RecentBlogPosts />
          <SocialMediaLinks />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default HomeLanding;